import { ID_PREFIXES } from './constants';
import isPatientUserId from './isPatientUserId';
import isStaffUserId from './isStaffUserId';
import isSubPatientUserId from './isSubPatientUserId';

const isPhysicianUserId = id =>
  id.startsWith(ID_PREFIXES.PHYSICIAN) ||
  (!isPatientUserId(id) && !isStaffUserId(id) && !isSubPatientUserId(id));

export default isPhysicianUserId;
